import React, { forwardRef } from 'react';

import { ContentSection, ContentSectionProps } from 'Storybook/components/local/ContentSection';

type SEOContentBlockProps = ContentSectionProps & { className?: string };

export const SEOContentBlock = forwardRef<HTMLDivElement, SEOContentBlockProps>(({ className, ...props }, ref) => (
  <div ref={ref} {...{ className }} data-testid='content-section'>
    <ContentSection {...{ ...props }} />
  </div>
));
